import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'

const { fireBlightMarginalRisk, fireBlightHighRisk, fireBlightExtremeRisk } = colors
const heatmapColors = [fireBlightMarginalRisk, fireBlightHighRisk, fireBlightExtremeRisk]

export const FireBlightHeatmapRow = () => {
  return (
    <div css={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div css={{ width: '100%', background: colors.grey50, borderRadius: 3, display: 'flex', padding: 10 }}>
        {heatmapColors.map((item) => (
          <div key={item} css={{ flex: 1, height: 12, background: item }} />
        ))}
      </div>
      <div
        css={{
          marginTop: 6,
          fontSize: 12,
          color: colors.white,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>{translate.phrases.banyanApp('Marginal Risk')}</div>
        <div>{translate.phrases.banyanApp('Extreme Risk')}</div>
      </div>
    </div>
  )
}
